/** @typedef	{import('../../OfferService/OfferFields').default} Response */

const categories = [
	{
		description: 'Heating, Ventilation, and Air Conditioning',
		label: 'HVAC',
		name: 'Your local	HVAC',
		postalCode: 61402,
	},
	{
		description: 'Accounting Services',
		label: 'Accountants',
		name: 'Johns	Accounting',
		postalCode: 81050,
	},
	{
		description: 'Electrical Services',
		label: 'Electricians',
		name: 'Electricians	R	Us',
		postalCode: 96254,
	},
	{
		description: 'General Handyman Services',
		label: 'Handyman Services',
		name: 'Handyman	Pro',
		postalCode: 36285,
	},
	{
		description: 'Locksmith Services',
		label: 'Locksmiths',
		name: 'Locksmith	Inc',
		postalCode: 85642,
	},
	{
		description: 'Pest Control Services',
		label: 'Pest Control',
		name: 'Pest	Control	Experts',
		postalCode: 15263,
	},
];

// required for type checking
const _categoryList = {
	groupList: {
		label: '',
		value: '',
	},
	offerImage: '',
	offerName: '',
	offerUrl: '',
	total: 0,
	vendorEmail: '',
	vendorPhone: '',
};

/** @returns {Response[]} */
export default function getGenericVendorsData() {
	return categories.map((category, index) => ({
		..._categoryList,
		id: `${category.postalCode}-${index}`,
		offerCategory: category.label,
		offerDescription: category.description,
		offerZip: `${category.postalCode}`,
		status: true,
		vendorName: category.name,
	}));
}
